<template>
    <v-form ref="usernameFurtherAssistance" v-model="valid" lazy-validation class="">
        <div class="username-recovery" v-if="!confirmedApiResponse">
            <div class="username-recovery__title">{{loginConstants.USERNAME_ASSISTANCE_SECURITY_INFO}}</div>
        </div>
        <div class="username-recovery__members" v-if="!confirmedApiResponse">{{loginConstants.MEMBERS_DATE_OF_BIRTH}}</div>
        <v-layout row v-if="!confirmedApiResponse">
            <v-flex>
                <div class="date-of-birth">
                    <v-menu ref="menu"
                            :close-on-content-click="false"
                            v-model="menu"
                            :nudge-right="40"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                            max-width="290px">
                        <v-text-field slot="activator"
                                      id="birth_date_input"
                                      data-qe-id="birth_date_input"
                                      v-model="user.birthDate"
                                      prepend-inner-icon="event"
                                      :rules="birthDateRules"
                                      :disabled="isSubmitting"
                                      required
                                      readonly></v-text-field>
                        <v-date-picker ref="picker"
                                       v-model="user.birthDate"
                                       :max="new Date().toISOString().substr(0, 10)"
                                       min="1900-01-01"
                                       @change="save"></v-date-picker>
                    </v-menu>
                </div>
            </v-flex>
        </v-layout>
        <div class="username-recovery__members" v-if="!confirmedApiResponse">{{loginConstants.MEMBERS_LAST_NAME}}</div>
        <v-layout row v-if="!confirmedApiResponse">
            <v-text-field
                    id="last_name_input"
                    data-qe-id="last_name_input"
                    name="LastName"
                    v-model="user.lastName"
                    validate-on-blur
                    :rules="lastNameRules"
                    :disabled="isSubmitting"
                    :onkeyup="resetError()"
                    required
                    v-on:keydown.enter.prevent
            ></v-text-field>
        </v-layout>
        <login-error></login-error>
        <v-card-actions>
            <v-layout row wrap v-if="!confirmedApiResponse">
                <v-btn
                        flat
                        large
                        id="return_to_home_btn"
                        data-qe-id="return_to_home_btn"
                        block
                        :class="confirmedApiResponse ? 'white--text' : 'ypo_blue--text'"
                        :color="confirmedApiResponse ? 'ypo_gold' : ''"
                        @click="returnToLogin()"
                        :disabled="isSubmitting"
                >
                    {{loginConstants.CANCEL}}
                </v-btn>
                <v-btn  v-if="!confirmedApiResponse"
                        id="submit_username_recovery_btn"
                        data-qe-id="submit_username_recovery_btn"
                        color="ypo_blue"
                        class="white--text"
                        @click="submit"
                        :disabled="checkEmptyObject || !valid || isSubmitting"
                        large
                        block
                >
                    {{loginConstants.SUBMIT}}
                </v-btn>
            </v-layout>
        </v-card-actions>
        <v-layout column class="text-center" pt-4>
            <v-flex xs12 class="spouse-partner__label">{{loginConstants.ARE_YOU_SPOUSE_PARTNER}}</v-flex>
            <v-flex xs12 class="spouse-partner__link">
                <span @click="changeCardState(loginConstants.componentNames.spousePartnerUsernameRecovery.component)"
                      data-qe-id="spouse-partner_username-recovery_link">
                    {{loginConstants.SPOUSE_PARTNER_USERNAME_RECOVERY_LINK}}
                </span>
            </v-flex>
        </v-layout>
    </v-form>
</template>
<script>
    import { mapActions, mapGetters } from 'vuex';
    import { storeGetters } from "../../../store/storeGetters.constant";
    import { storeAction } from "../../../store/storeActions.constant";
    import { loginConstants } from '../login.constants';
    import LoginError from "../LoginError";
    import UsernameRecoveryOptions from "../UsernameRecoveryOptions/UsernameRecoveryOptions";

    export default {
        name: 'UsernameFurtherAssistance',
        components: { LoginError, UsernameRecoveryOptions },
        data: () => ({
            loginConstants,
            valid: true,
            componentNames: loginConstants.componentNames,
            user: {
                lastName: null,
                birthDate: null,
            },
            confirmedApiResponse: null,
            menu: false,
            lastNameRules: [
                v => !!v || loginConstants.errors.LAST_NAME_IS_REQUIRED,
            ],
            birthDateRules: [
                v => !!v || loginConstants.errors.BIRTHDATE_REQUIRED,
            ],
        }),
        props: {
            changeCardState: Function,
            toggleProgressIndicator: Function,
            isSubmitting: Boolean,
            returnToLogin: Function,
        },
        watch: {
            menu(val) {
                if (val) {
                    this.$nextTick(() => { this.$refs.picker.activePicker = 'YEAR'; });
                }
            },
        },
        methods: {
            ...mapActions({
                submitUsernameFurtherAssistance: `auth/${storeAction.submitUsernameFurtherAssistance}`,
                clearErrorOnStateChange: `auth/${storeAction.handleLoginErrorMessage}`,
            }),
            submit() {
                this.toggleProgressIndicator();

                if (this.$refs.usernameFurtherAssistance.validate()) {
                    this.submitUsernameFurtherAssistance(this.user)
                        .then((resp) => {
                            this.toggleProgressIndicator();
                            this.confirmedApiResponse = resp.data;
                            this.changeCardState(loginConstants.componentNames.usernameRecoveryOptions.component);
                        })
                        .catch(() => {
                            this.toggleProgressIndicator();
                        });
                }
            },
            resetError() {
                if (!(this.user.birthDate && this.user.lastName)) {
                    this.clearErrorOnStateChange(null);
                }
            },
            save(date) {
                this.$refs.menu.save(date);
            },
        },
        computed: {
            ...mapGetters({
                userRecoveryOptions: storeGetters.userRecoveryOptions,
            }),
            checkEmptyObject() {
                return Object.values(this.user).some((x) => {
                    return x === null || x === '';
                });
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';
    @import '../../../common/styles/_commonClasses.scss';
    @import '../../../common/styles/_responsive.scss';

    .username-recovery {
        display: flex;
        flex-direction: column;

        &__title {
            padding: 10px 0 5px;
            font-size: 15px;
            color:$black;
            opacity: 0.9;
            font-family: 'Noto Sans', sans-serif;
        }

        &__subTitle {
            padding: 5px 10px 20px;
            text-align: center;
            font-size: 16px;
            color: $ypo-blue;
        }


        &__success {
            padding: 10px 5px;
            border-top: 1px solid $ypo-gray;
            display: flex;
            flex-wrap: wrap;

            &-message {
                color: $ypo-blue;
            }

            &-email {
                color: $ypo-gold;
                padding-left: 5px;
            }
        }

        &__members {
            font-size: 14px;
            font-weight: bold;
            font-family: "Noto Sans";
            line-height: 24px;
            height: 24px;
            width: 312px;
            margin-bottom: -12px;
            margin-top: 12px;
        }

        &__resend {
            color: $ypo-blue-secondary;
        }
    }
    .v-btn__content{
        @include breakpoint(xs) {
            font-size: 12px !important;
        }
    }

    .v-card__actions {
        padding-right: 0 !important;
        padding-left: 0 !important;
        @include breakpoint(xs) {
            padding: 0 !important;
        }
    }

    .date-of-birth, .month-of-birth {
        padding-right: 10px;
    }
    
    .spouse-partner {
        &__label {
            color: $ypo-blue;
            font-weight: 600;
            margin-bottom: 5px;
        }

        &__link {
            color: $ypo-gold;
            cursor: pointer;

            &:hover {
                text-decoration: underline;
            }
        }
    }


</style>
